export type BookingMode = "digital" | "onsite";

export type BookingAction =
  | { type: "contact"; url: string }
  | { type: "booking"; digital?: string; onsite?: string };

/** General Healthy contact form (Övriga intyg) — also used on the private contact page. */
export const HEALTHY_CONTACT_FORM_URL = "https://intygslakaren.hlthy.se/contactform?q=uWFnbKIL";

/** Booking + contactform links from Intygslakaren_bokningslankar.xlsx */
export const BOOKING_ACTION_BY_SLUG: Partial<Record<string, BookingAction>> = {
  "adoptionsintyg": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=XsYr60PY" },
  "afs-handintensivt": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=lUPdr2Gr" },
  "afs-vibrationer": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=VfhNY_-a" },
  "au-pair": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=WxFBc8iq",
    onsite: "https://intygslakaren.hlthy.se/booking?q=kGSSW7lD",
  },
  "fallskarmsintyg": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=MNySqLmG" },
  "fit-for-fly": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=kBx4u9_U",
    onsite: "https://intygslakaren.hlthy.se/booking?q=5JMNw03Z",
  },
  "forstadagsintyg": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=vMjlJjMn",
    onsite: "https://intygslakaren.hlthy.se/booking?q=hP3aM-DQ",
  },
  "hogre-behorighet": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=mQm-eWOV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=tn0AyP9_",
  },
  // Same HLTHY destinations as högre behörighet (clinic-supplied shared booking links)
  "c-ce": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=mQm-eWOV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=tn0AyP9_",
  },
  "d-de": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=mQm-eWOV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=tn0AyP9_",
  },
  "buss-lastbil": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=mQm-eWOV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=tn0AyP9_",
  },
  "taxi": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=mQm-eWOV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=tn0AyP9_",
  },
  "utlandsstudier": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=R-vRV8lz",
    onsite: "https://intygslakaren.hlthy.se/booking?q=-uHyezAJ",
  },
  "invaliditetsintyg": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=sgN8JYkF" },
  "droger-alkohol": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=cQP4wIDJ",
    onsite: "https://intygslakaren.hlthy.se/booking?q=cvEjcNfi",
  },
  "alkolas": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=F_BDLQiV",
    onsite: "https://intygslakaren.hlthy.se/booking?q=Rt6-q1Zk",
  },
  "salivtest": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=PlPFyv_H" },
  "urinprov": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=0AQi8nP4" },
  "korkort-diabetes": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=xmLYr0Kp",
    onsite: "https://intygslakaren.hlthy.se/booking?q=eOe1NT3-",
  },
  "korkort-hjarta": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=dIJAclYY",
    onsite: "https://intygslakaren.hlthy.se/booking?q=BB3H_Jp_",
  },
  "installd-resa": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=ddgzbuuF",
    onsite: "https://intygslakaren.hlthy.se/booking?q=rXFSbgMW",
  },
  "nattarbete": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=Z4L1yRMS" },
  "reseintyg-gravid": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=-606SJYd",
    onsite: "https://intygslakaren.hlthy.se/booking?q=ZZC2TXyt",
  },
  "sjofolksintyg": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=KTP-6fmm" },
  "tavlingsintyg": {
    type: "booking",
    digital: "https://intygslakaren.hlthy.se/booking?q=D2lrOie2",
    onsite: "https://intygslakaren.hlthy.se/booking?q=yooAfVdC",
  },
  "intyg-forsakring": { type: "booking", onsite: "https://intygslakaren.hlthy.se/booking?q=3m05KQOi" },

  // Kontaktformulär sheet
  "afs-bly": { type: "contact", url: "https://intygslakaren.hlthy.se/contactform?q=ISt0x-4e" },
  "afs-klattring": { type: "contact", url: "https://intygslakaren.hlthy.se/contactform?q=mp-S9Mm2" },
  "afs-mast-stolpe": { type: "contact", url: "https://intygslakaren.hlthy.se/contactform?q=oxgvKLEd" },
  "oguk": { type: "contact", url: "https://intygslakaren.hlthy.se/contactform?q=8t-FbFVv" },
  "offshore": { type: "contact", url: "https://intygslakaren.hlthy.se/contactform?q=apfgEzcv" },
  "ovriga": { type: "contact", url: HEALTHY_CONTACT_FORM_URL },

  // Enquiry-only / not listed — fall back to Övriga intyg contact form
  "korkort-adhd": { type: "contact", url: HEALTHY_CONTACT_FORM_URL },
  "afs-asbest": { type: "contact", url: HEALTHY_CONTACT_FORM_URL },
  "afs-allergi-produkter": { type: "contact", url: HEALTHY_CONTACT_FORM_URL },
  "afs-allergi-kemiska": { type: "contact", url: HEALTHY_CONTACT_FORM_URL },
};

export const getBookingAction = (slug: string): BookingAction =>
  BOOKING_ACTION_BY_SLUG[slug] ?? { type: "contact", url: HEALTHY_CONTACT_FORM_URL };

export const isBookableAction = (action: BookingAction): action is Extract<BookingAction, { type: "booking" }> =>
  action.type === "booking" && Boolean(action.digital || action.onsite);

export const isContactAction = (action: BookingAction): action is Extract<BookingAction, { type: "contact" }> =>
  action.type === "contact";

export const getContactFormUrl = (action: BookingAction): string | null =>
  action.type === "contact" ? action.url : null;

export const getAvailableBookingModes = (action: BookingAction): BookingMode[] => {
  if (action.type !== "booking") return [];
  const modes: BookingMode[] = [];
  if (action.digital) modes.push("digital");
  if (action.onsite) modes.push("onsite");
  return modes;
};

export const isDualBookingAction = (action: BookingAction) => getAvailableBookingModes(action).length > 1;

export const getBookingUrl = (action: BookingAction, mode?: BookingMode): string | null => {
  if (action.type !== "booking") return null;
  if (mode === "digital") return action.digital ?? null;
  if (mode === "onsite") return action.onsite ?? null;
  return action.onsite ?? action.digital ?? null;
};
